import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Copy, Users, Share2, Ticket, Sparkles } from "lucide-react";
import Btn from "../components/Btn";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Referral() {
  const { refresh } = useAuth();
  const [info, setInfo] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/referral").then(({ data }) => setInfo(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!info) return <div className="grid place-items-center py-16"><div className="w-10 h-10 rounded-full border-4 border-su-border border-t-su-primary animate-spin" /></div>;

  const link = `${window.location.origin}/auth?ref=${info.code}`;
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Disalin!"); };
  const shareWA = () => window.open(`https://wa.me/?text=${encodeURIComponent("Yuk gabung SkorUp.io & naikkan skor SNBT/CPNS-mu! Pakai kodeku " + info.code + ": " + link)}`, "_blank");

  const apply = async () => {
    setBusy(true);
    try { await api.post("/referral/apply", { code: code.trim() }); toast.success("Kode diterapkan! Bonus masuk 🎁"); await refresh(); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="font-heading font-black text-2xl sm:text-3xl flex items-center gap-2"><Gift className="w-7 h-7 text-su-success" /> Ajak Teman</h1>
        <p className="text-su-muted font-medium">Teman dapat {info.reward.friend}, kamu dapat {info.reward.you}.</p>
      </div>

      <div className="card-chunky p-6">
        <p className="text-xs font-heading font-black uppercase text-su-muted mb-2">Kode referral kamu</p>
        <div className="flex items-center gap-2 mb-4">
          <div className="flex-1 font-mono font-bold text-2xl tracking-wider bg-su-primary/10 text-su-primary rounded-2xl px-4 py-3 text-center" data-testid="referral-code">{info.code}</div>
          <Btn variant="ghost" data-testid="copy-code" onClick={() => copy(info.code)}><Copy className="w-5 h-5" /></Btn>
        </div>
        <p className="text-xs font-heading font-black uppercase text-su-muted mb-2">Link undangan</p>
        <div className="flex items-center gap-2 mb-4">
          <input readOnly value={link} className="flex-1 px-3 py-2.5 rounded-xl border-2 border-su-border bg-su-bg text-sm font-medium outline-none" />
          <Btn variant="ghost" data-testid="copy-link" onClick={() => copy(link)}><Copy className="w-4 h-4" /></Btn>
        </div>
        <Btn variant="success" className="w-full" onClick={shareWA}><Share2 className="w-4 h-4" /> Bagikan via WhatsApp</Btn>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="card-chunky p-5 text-center">
          <Users className="w-6 h-6 text-su-primary mx-auto mb-1" />
          <p className="font-heading font-black text-2xl" data-testid="referral-count">{info.count}</p>
          <p className="text-xs font-bold text-su-muted uppercase">Teman diajak</p>
        </div>
        <div className="card-chunky p-5 text-center">
          <Ticket className="w-6 h-6 text-su-secondaryShadow mx-auto mb-1" />
          <p className="font-heading font-black text-2xl">{info.count * 10}</p>
          <p className="text-xs font-bold text-su-muted uppercase">Token diperoleh</p>
        </div>
      </div>

      {!info.referred_by && (
        <div className="card-chunky p-6">
          <h2 className="font-heading font-black text-lg mb-1 flex items-center gap-2"><Sparkles className="w-5 h-5 text-su-secondary" /> Punya kode teman?</h2>
          <p className="text-su-muted font-medium text-sm mb-3">Masukkan kode referral untuk dapat bonus token & energi.</p>
          <div className="flex items-center gap-2">
            <input data-testid="apply-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="SKORXXXXXX"
              className="flex-1 px-4 py-3 rounded-2xl border-2 border-su-border bg-su-bg font-mono font-bold outline-none focus:border-su-primary" />
            <Btn data-testid="apply-code" onClick={apply} disabled={busy || !code.trim()}>Terapkan</Btn>
          </div>
        </div>
      )}
    </div>
  );
}
